import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAllCoursesApi,
  createCourseApi,
  deleteCourseApi,
  updateCourseApi,
} from "../../apis/coursesAndDiscussion";

// Get all courses
export const getAllCourses = createAsyncThunk("course/get-all", async () => {
  const response = await getAllCoursesApi();
  return response.data?.data;
});

// Create a course
export const createCourses = createAsyncThunk(
  "course/create",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await createCourseApi(formData);
      return response.data?.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to create course."
      );
      
    }
  }
);

// Delete a course
export const deleteCourse = createAsyncThunk(
  "course/delete",
  async (id,  { rejectWithValue }) => {
    try {
      await deleteCourseApi(id);
      return id; // Return deleted course ID to update state
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete course"
      );
    }
  }
);

// Update a course
export const updateCourse = createAsyncThunk(
  "course/update",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await updateCourseApi(id, formData);
      return response.data?.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to update course"
      );
    }
  }
);


const courseSlice = createSlice({
  name: "courses",
  initialState: {
    courses: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Get all courses
      .addCase(getAllCourses.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllCourses.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.courses = action.payload;
      })
      .addCase(getAllCourses.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error?.message || "Something went wrong.";
      })

      // Create a course
      .addCase(createCourses.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createCourses.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.courses.push(action.payload);
      })
      .addCase(createCourses.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to create course.";
      })

      // Delete a course
      .addCase(deleteCourse.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteCourse.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.courses = state.courses.filter(
          (course) => course.id !== action.payload
        ); // Remove the deleted course from state
      })
      .addCase(deleteCourse.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to delete course.";
      })

      // Update a course
      .addCase(updateCourse.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateCourse.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.courses = state.courses.map((course) =>
          course.id === action.payload.id ? action.payload : course
        ); // Update the course in state
      })
      .addCase(updateCourse.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to update course.";
      });
  },
});

export default courseSlice.reducer;
